import {postMethod} from '~/api'

async function post(request) {
    return await postMethod('/api/prepareDynamicPackageBook', request)
}

export {post}
